import React, { useEffect } from 'react';
import { Box, Card, CardContent, Typography, List, ListItem, ListItemIcon, ListItemText, IconButton, Chip, Stack, Button } from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks';
import { fetchNotifications, markAllNotificationsRead, markNotificationRead } from '../store/slices/systemSlice';
import { usePageMeta } from '../hooks/usePageMeta';

const Notifications: React.FC = () => {
  usePageMeta('Notifications – AskNow', 'View, read, and manage your notifications.');
  const dispatch = useAppDispatch();
  const { notifications = [], isLoading } = useAppSelector((s) => (s as any).system);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Notifications</Typography>
        <Stack direction="row" spacing={1}>
          <Chip label={`${notifications.filter((n: any) => !n.read).length} Unread`} color="secondary" size="small" />
          <Button size="small" variant="outlined" startIcon={<MarkEmailReadIcon />} onClick={() => dispatch(markAllNotificationsRead())}>Mark all read</Button>
        </Stack>
      </Box>

      <Card>
        <CardContent>
          <List>
            {notifications.length === 0 && (
              <Typography variant="body2" color="text.secondary">No notifications yet.</Typography>
            )}
            {notifications.map((n: any) => (
              <ListItem
                key={n.id}
                secondaryAction={
                  !n.read ? (
                    <IconButton edge="end" aria-label="mark-read" onClick={() => dispatch(markNotificationRead(n.id))}>
                      <CheckCircleIcon />
                    </IconButton>
                  ) : undefined
                }
                sx={{
                  mb: 1,
                  border: (t) => `1px solid ${t.palette.divider}`,
                  borderRadius: 2,
                  background: (t) => n.read ? 'transparent' : `linear-gradient(118deg, ${t.palette.secondary.main}11, ${t.palette.primary.main}1A)`,
                }}
              >
                <ListItemIcon>
                  <NotificationsActiveIcon color={n.read ? 'inherit' : 'secondary'} />
                </ListItemIcon>
                <ListItemText
                  primary={n.title || 'Notification'}
                  secondary={n.message || '—'}
                  primaryTypographyProps={{ fontWeight: n.read ? 500 : 700 }}
                />
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Notifications;


